import React, { useEffect, useRef } from "react";
import './TeamSection.css';
import AzizaPfp from '../images/team/Aziza_HARMOUCHE.jpeg';
import OussamaPfp from '../images/team/Oussama_EL_MAHBOUBI.JPG';
import IkramePfp from '../images/team/Ikrame_TAGAA.JPG';
import MyriamPfp from '../images/team/Myriam_OTTMANI.JPG';
import AhmedPfp from '../images/team/Ahmed_LEBBAR.JPG';
import MehdiPfp from '../images/team/Mehdi_ER-RAGABI.JPG';
import IkhlassePfp from '../images/team/Ikhlasse_RAHMOUNE.JPG';
import AmmarPfp from '../images/team/Ammar_HADDAD.JPG';
import WiamPfp from '../images/team/Wiam_BAHILI.JPG';
import ElMehdiPfp from '../images/team/El_Mehdi_MHAIDI.jpg';
import AyoubPfp from '../images/team/Ayoub_AGMAH.JPG';
import RachidPfp from '../images/team/Rachid_AIT_JELLOUL.JPG';
import NadaPfp from '../images/team/Nada_SABRI.JPG';
import ImadPfp from '../images/team/Imad_LOTFI.JPG';
import MohamedPfp from '../images/team/Mohamed_ELABRIDI.JPG';
import HibaPfp from '../images/team/HIBA_BOUADDI.JPG';
import MarwaPfp from '../images/team/Marwa_DIALLO.JPG';
import MohammedPfp from '../images/team/Mohammed_EL_BARAKA.JPG';
import ZinebPfp from '../images/team/Zineb_LGHALOU.JPG';
import YassirPfp from '../images/team/Yassir_AGOUZOULE.JPG';
import SalmaPfp from '../images/team/Salma_Kerrach.JPG';
import YoussefPfp from '../images/team/Youssef_BENAOUDA.png';
import AymanPfp from '../images/team/Ayman_JABAL.jpeg';


const TeamSection = () => {
  const observerRef = useRef(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observerRef.current.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px"
    });

    const items = document.querySelectorAll('.c-partner-item, .team-section .t-display-1');
    items.forEach((item) => observerRef.current.observe(item));

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return (
    <>
      <section className="c-section team-section">
        <div className="o-container">
          <h1 className="t-display-1 is-serif">
            EJE Mandate 25/26
          </h1>
          <div id="w-node-b1158db7-c8c3-03e2-77dc-ecc0854be950-94802662" className="w-dyn-list">
            <div role="list" className="o-grid members w-dyn-items">
              
              {/* Présidente */}
              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/in/aziza-harmouche-5aa25426a/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={AzizaPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Aziza HARMOUCHE
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Présidente
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              {/* Vice-président */}
              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/in/oussama-el-mahboubi-99a8402b8/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={OussamaPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Oussama EL MAHBOUBI
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Vice-président
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              {/* Secrétaire générale et trésorière */}
              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={IkramePfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Ikrame TAGAA
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Secrétaire générale et trésorière
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              {/* Directeurs Missions & Qualité */}
              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/in/myriam-ottmani-157966287/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={MyriamPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Myriam OTTMANI
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directrice Missions & Qualité
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/in/ahmed-lebbar-3400bb255/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={AhmedPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Ahmed LEBBAR
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directeur Missions & Qualité
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={MehdiPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Mehdi ER-RAGABI
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directeur Missions & Qualité
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={IkhlassePfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Ikhlasse RAHMOUNE
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directrice Missions & Qualité
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={AmmarPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Ammar HADDAD
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directeur Missions & Qualité
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={YoussefPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Youssef BENAOUDA
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directeur Missions & Qualité
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={WiamPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Wiam BAHILI
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directrice Missions & Qualité
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={ElMehdiPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    El Mehdi MHAIDI
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directeur Missions & Qualité
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={AyoubPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Ayoub AGMAH
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directeur Missions & Qualité
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              {/* Directeurs Événements et Workshops */}
              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/in/rachid-ait-jalloul-56497a225/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={RachidPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Rachid AIT JELLOUL
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directeur Événements et Workshops
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={NadaPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Nada SABRI
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directrice Événements et Workshops
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={ImadPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Imad LOTFI
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directeur Événements et Workshops
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={AymanPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Ayman JABAL
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directeur Événements et Workshops
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              {/* Directeur IT */}
              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={MohamedPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Mohamed ELABRIDI
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directeur IT
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              {/* Directrice Partenariats */}
              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={HibaPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    HIBA BOUADDI
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directrice Partenariats
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              {/* Directeurs Sponsoring */}
              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={MarwaPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Marwa DIALLO
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directrice Sponsoring
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={MohammedPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Mohammed EL BARAKA
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directeur Sponsoring
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={ZinebPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Zineb LGHALOUI
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directrice Sponsoring
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              {/* Directeurs Marketing */}
              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/in/yassir-el-qaqi/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={YassirPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Yassir AGOUZOULE
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directeur Marketing
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

              <div role="listitem" className="c-partner-item w-dyn-item">
                <div className="c-partner-trigger"></div>
                <a className="c-btn partner-tag w-inline-block" href="https://www.linkedin.com/">
                  <div className="c-btn-inner">
                    <p className="t-body-4 is-medium">Linkedin</p>
                      <div className="c-icon btn-arrow w-embed">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0.5C7.04875 1.33538 4.51216 1.67936 0.878024 1.28624L0.756027 2.68673C3.31699 2.957 5.19504 2.93243 7.0975 2.4656L-0.000291876 9.5172L0.975286 10.5L8.04869 3.39926C7.58521 5.3403 7.56076 7.20762 7.82897 9.81204L9.21922 9.68919C8.82909 6.02826 9.19503 3.4484 10 0.5Z" ></path>
                          </svg>
                      </div>
                  </div>
                </a>
                <div className="c-img-contain margin-24 br-16">
                  <img loading="lazy" src={SalmaPfp} className="c-img"></img>
                </div>
                <div className="margin-24">
                  <div className="t-body-1">
                    Salma Kerrachi
                  </div>
                </div>
                <div className="margin-4">
                  <div className="t-body-3">
                    Directrice Marketing
                  </div>
                </div>
                <div className="c-line partner"></div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default TeamSection;
